import type { AnalyticsEvents } from './contants';
import Analytics from '../../../../../modules/analytics';

export const sendAnalytics = async (event: AnalyticsEvents) => {
  await Analytics.track(event);
};
